<template>
    
           
  <div class="row mb-3">

    <div v-if="available.length" class="col-6">
      <h5 v-if="!selected.length">Contact is not on any mailing lists. Add contact to:</h5>
      <h5 v-if="selected.length">Add contact to:</h5>

      <draggable
          :list="available"
          class="list-group h-100"
          draggable=".item"
          group="a"
      >
        <div class="list-group-item item" v-for="(mailinglist,idx) in available" :key="mailinglist.name">
          {{ mailinglist.name }} <a href="javascript:" @click="addContactToMailinglist(idx)" class="btn btn-sm btn-green pull-right">Add</a>
        </div>
      </draggable>
    </div>

    <div v-if="selected.length" class="col-6">
      <h5>Contact is on the following mailing lists:</h5>
      <draggable :list="selected" class="list-group h-100" draggable=".item" group="a" @change="updateContactMailinglists">
        <div
          class="list-group-item item"
          v-for="(mailinglist,idx) in selected"
          :key="mailinglist.name"      
        >
          {{ mailinglist.name }}  <a href="javascript:" @click="removeContactFromMailinglist(idx)" class="btn btn-sm btn-primary pull-right">Remove</a>
        </div>

      </draggable>
    </div>





  </div>

    
</template>

<script>

import axios from 'axios';
import Noty from 'noty';

export default {
    mounted(){
        this.getMailinglists();
    },
  components: {
    draggable
  },
  props: [
    'id'
  ],
  data() {
    return {
      contactId: this.id,
      available: [],
      selected: []
    };
  },
  methods: {
    getMailinglists: function() {
    

        var vm = this;

        axios.get('/contacts/contact/'+this.contactId+'/list-mailinglists').then(response => {

          vm.selected = response.data.selected_mailinglists;
          vm.available = response.data.available_mailinglists;

        }).catch(() => console.warn('Oh. Something went wrong. getMailinglists'));

    },
    updateContactMailinglists: function() {
      
        var vm = this;

        var mailinglist_ids = $.map(vm.selected, function(o) { return o["id"]; })

        axios.post('/contacts/contact/'+this.contactId+'/sync-mailinglists',{mailinglists:mailinglist_ids}).then(response => {         
          

          Vue.nextTick(function(){
            vm.getMailinglists();
          });


        }).catch(() => console.warn('Oh. Something went wrong. getMailinglists'));

    },
    addContactToMailinglist: function(idx){

      let mailinglist = this.available[idx];

      this.selected.push(mailinglist);
      this.updateContactMailinglists();

     new Noty({
        text: 'Contact has been added to '+ mailinglist.name +' list.',
        type: 'success',
        theme: 'bootstrap-v4',
        layout: 'topCenter',
        timeout: 2000
      }).show();

    },
    removeContactFromMailinglist: function(idx){

      let mailinglist = this.selected[idx];

      this.selected.splice(idx,1);
      this.updateContactMailinglists();


     new Noty({
        text: 'Contact has been removed from '+ mailinglist.name +' list.',
        type: 'warning',
        theme: 'bootstrap-v4',
        layout: 'topCenter',
        timeout: 2000
      }).show();

    }


  }
};

</script>